import React from "react";
import { Input, Label } from "@fluentui/react-components";
import { usePowder } from "../redux/ReduxContext";


const cardClass = " bg-white dark:bg-oi-dark-background p-4 mb-4";
const labelClass = "mb-2 block text-[11px] font-semibold text-primary-dark dark:text-primary-light whitespace-nowrap";
const fieldClassName =
    "mt-2 h-10 w-full border border-primary-dark dark:border-primary-light bg-primary-light dark:bg-primary-dark px-3 focus:outline-none";

export default function PowderInfo({ }) {
    const { state, dispatch } = usePowder();
    return (
        <div className={`${cardClass} grid grid-cols-1 gap-3 md:grid-cols-2`}>
            <div>
                <Label className={labelClass}>Title</Label>

                <input
                    className={fieldClassName}
                    value={state.title}
                    placeholder="Cr/Co 15 kolserie med PRZ F"
                    onChange={(e) => dispatch({ type: 'SET_FIELD', payload: { field: 'title', value: e.target.value } })}
                />
            </div>
            <div>
                <Label className={labelClass}>Requester</Label>
                <input
                    className={fieldClassName}
                    value={state.author}
                    disabled
                />
            </div>
        </div>
    );
}

